import {APP_INITIALIZER} from '@angular/core';
import {fetchAuthorizedUserFactory} from 'app/core/app-initializers/fetch-authorized-user.initializer';
import {fetchSvgSourcesFactory} from 'app/core/app-initializers/fetch-svg-sources.factory';
import {safeSubscribersFactory} from 'app/core/app-initializers/safe-subscribe.initializer';
import {setCurrentUserToSentry} from 'app/core/app-initializers/set-current-user-to-sentry.factory';
import {ErrorFabricService} from 'app/core/error-handler/error-fabric.service';
import {ErrorNotifierService} from 'app/core/error-handler/error-notifier.service';
import {Sentry} from 'app/core/error-handler/sentry.service';
import {SvgService} from 'app/core/services/svg.service';
import {AuthService} from '../services/auth.service';
import {DemoService} from 'app/core/services/demo.service';
import {ClientAnalyticsInitializerFactory} from 'app/core/app-initializers/client-analytics.initializer';
import {FacebookPixelFactory} from 'app/core/app-initializers/facebook-pixel.initializer';
import {DOCUMENT} from '@angular/common';
import {ClientAnalyticsService} from 'app/core/services/client-analytics.service';
import {ThemeCustomizationService} from 'app/core/services/theme-customization.service';
import {YandexMetricaService} from 'app/core/services/yandex-metrica.service';
import {PosthogService} from 'app/core/services/analytics/posthog.service';
import {posthogInit} from 'app/core/app-initializers/posthog.provider';
import {UtmService} from 'app/features/sign-up/services/utm.service';
import {utmTagsInitializerFactory} from 'app/core/app-initializers/utms.providers';

export const APP_INITIALIZERS = [
    {
        provide: APP_INITIALIZER,
        useFactory: utmTagsInitializerFactory,
        deps: [UtmService],
        multi: true,
    },
    {
        provide: APP_INITIALIZER,
        useFactory: fetchAuthorizedUserFactory,
        deps: [AuthService, ThemeCustomizationService],
        multi: true,
    },
    {
        provide: APP_INITIALIZER,
        useFactory: setCurrentUserToSentry,
        deps: [Sentry, AuthService],
        multi: true,
    },
    {
        provide: APP_INITIALIZER,
        useFactory: posthogInit,
        deps: [AuthService, PosthogService, DemoService],
        multi: true,
    },
    {
        provide: APP_INITIALIZER,
        useFactory: ClientAnalyticsInitializerFactory,
        deps: [DemoService, AuthService, ClientAnalyticsService, YandexMetricaService],
        multi: true,
    },
    {
        provide: APP_INITIALIZER,
        useFactory: FacebookPixelFactory,
        deps: [DOCUMENT, DemoService, AuthService],
        multi: true,
    },
    {
        provide: APP_INITIALIZER,
        useFactory: safeSubscribersFactory,
        deps: [ErrorNotifierService, ErrorFabricService],
        multi: true,
    },
    {
        provide: APP_INITIALIZER,
        useFactory: fetchSvgSourcesFactory,
        deps: [SvgService],
        multi: true,
    },
];
